<template>
  <td class="st-table-item__data-cell">
    <span class="st-table-item__data-cell__mobile-header">{{
      header.name
    }}</span>
    <div
      v-if="data.component"
      @click="data.clickable ? handleItemClick($event) : () => {}"
      @keydown.enter="data.clickable ? handleItemClick($event) : () => {}"
    >
      <component :is="data.component" v-bind="data.componentProps" />
    </div>
    <span v-else class="st-table-item__data-cell__span"> {{ data.value }}</span>
  </td>
</template>

<script>
export default {
  components: {},
  props: {
    data: Object,
    header: Object,
  },
  methods: {
    handleItemClick(e) {
      this.$emit("on-item-click");
      e.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.st-table-item__data-cell {
  padding: rem-calc(18) rem-calc(10);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  word-break: break-all;
  &__span {
    color: $dark-grey;
    font-size: rem-calc(16);
  }
  @include large {
    display: table-cell;
    padding: rem-calc(22);
  }
  &__mobile-header {
    display: table-header-group;
    font-weight: $semi-bold;
    @include large {
      display: none;
    }
  }
}
</style>
